<template>
  <v-card class="w-full pa-2">
    <v-checkbox 
      v-model="select" 
      class="ma-0 pa-0" 
      :color="$partnerACL.getButtonColor()"
      style="height: 30px;"
    >
      <template v-slot:label>
        <div v-if="[3, 4].includes(fareType)">
          <span class="f-bold f-s-xs" style="color: #000;">{{ $t('TicketMultiTrip') }}</span>
        </div>
        <div v-else-if="[9, 10].includes(fareType)">
          <span class="f-bold f-s-xs" style="color: #000;">{{ $t('GroupTicketMultiTrip') }}</span>
        </div>
        <div v-else>
          <span class="f-bold f-s-xs" style="color: #000;">{{ itemName }}</span>
        </div>
      </template>
    </v-checkbox>
    <hr />

    <div v-if="[3, 4, 9, 10].includes(fareType)">
      <div class="d-flex flex-row justify-between" style="place-items: anchor-center;">
        <div class="d-flex flex-column">
          <span class="f-bold f-s-xs">{{ itemName }}</span>
          <span 
            v-if="routeInformation && routeInformation.fare_rule.max_trip == 0" 
            class="f-s-xs"
          >{{ $t("UnlimitedTrips") }}</span>
          <span 
            v-else-if="$i18n.locale == 'vi' && routeInformation && routeInformation.fare_rule.max_trip != 0"
            class="f-s-xs"
          >Tập {{ routeInformation && routeInformation.fare_rule.max_trip }} vé</span>
          <span 
            v-else
            class="f-s-xs"
          >{{ routeInformation && routeInformation.fare_rule.max_trip + ' ' + $t("Kali Perjalanan")}}</span>
        </div>

        <div class="d-flex flex-column" style="min-width: 80px;">
          <span class="f-s-xs" style="margin-left: 3px;">{{ $t("Qty ") + " : " + quantity + " " + $t("Ticket")}} </span>
          <span class="num-135000-v-nd break-word">
            {{ new Intl.NumberFormat('id-ID', {
              style: 'currency',
              currency: selectedCurrency,
              minimumFractionDigits: 2
            }).format(priceTotal) }}
          </span>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="d-flex flex-row justify-between" style="place-items: anchor-center;">
        <timeline-dashed :route="timelineDashed"/>
        <div class="d-flex flex-column" style="min-width: 80px;">
          <span class="f-s-xs" style="margin-left: 3px;">{{ $t("Qty ") + " : " + quantity + " " + $t("Ticket")}} </span>
          <span class="num-135000-v-nd break-word">
            {{ new Intl.NumberFormat('id-ID', {
            style: 'currency',
            currency: selectedCurrency,
            minimumFractionDigits: 2
          }).format(priceTotal) }}
          </span>
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
import store from "@/store";
import TimelineDashed from "@/components/TimelineDashed.vue";

export default {
  name: "CardCartTicket",
  components: {
    TimelineDashed
  },
  lastprice: "",
  props: {
    fareID: {
      type: String,
      default: ""
    },
    fareType: {
      type: Number,
      default: 0
    },
    itemName: {
      type: String,
      default: ""
    },
    routeInformation: {
      type: Object,
      default: () => { return null }
    },
    price: {
      type: Number,
      default: 0
    },
    priceTotal: {
      type: Number,
      default: 0
    },
    currency: {
      type: String,
      default: "VNĐ"
    },
    clickInformation: {
      /*  set handler function after click oke/ yes
       */
      type: Function,
      required: false,
    },
    value: {
      default: 0,
      type: Number,
    },
    min: {
      default: 1,
      type: Number,
    },
    max: {
      default: 0,
      type: Number,
    },
    quantity: {
      default: 0,
      type: Number,
    },
    selected: {
      type: Boolean,
      default: true
    },
    index: {
      type: Number
    },
    customerCartID: {
      type: Number,
    },
    customerID: {
      type: String,
    }
  },
  data() {
    return {
      newValue: 0,
      buy: false,
    };
  },
  computed: {
    select: {
      get() {
        return this.selected
      },
      set(val) {
        this.changeSelected(val, this.index)
      },
    },
    items() {
      return store.state.purchaseticket.cart
    },
    countCart() {
      return store.state.purchaseticket.countCart
    },
    subTotal() {
      let itemTemp = this.items.filter((el) => {
        return el.selected == true;
      });
      let _subtotal = itemTemp.map(
        (itm) => this.convertPriceByCurrency(itm.priceTotal, itm.currencyCode)
      );
      let total;
      if (_subtotal.length > 1) {
        total = _subtotal.reduce((a, b) => a + b);
      } else {
        total = _subtotal;
      }
      return total;
    },
    discountData() {
      return store.state.purchaseticket.discount
    },
    selectedCurrency() {
      return this.$store.state.purchaseticket.currency ? this.$store.state.purchaseticket.currency.code : ""
    },
    timelineDashed() {
      return {
        origin: this.routeInformation ? this.routeInformation.origin_code : '',
        long_origin: this.routeInformation ? this.routeInformation.origin_loc : '',
        destination: this.routeInformation ? this.routeInformation.destination_code : '',
        long_destination: this.routeInformation ? this.routeInformation.destination_loc : ''
      }
    }
  },
  mounted() {
  },
  methods: {
    clickRouteInformation() {
      this.$store.commit("moduleUi/ROUTE_INFORMATION", this.routeInformation);
      this.clickInformation();
    },
    clickBuy() {
      this.buy = true;
      this.$emit("buy", true);
      this.mpplus();
    },
    // changeSelected(val, index) {
    //   store.commit("purchaseticket/CHANGE_SELECTED", { index, val });
    // },
    async changeSelected() {
      let payload = {
        customerCartID: this.customerCartID,
        customerID: this.customerID
      };
      await this.$store
        .dispatch("purchaseticket/selectcart", payload)
        .then((response) => {
          if (response.status) {
            const param = {
              index: this.index,
              val: response.data
            }
            const currentCart = this.items.filter(fx => fx.customerCartIDs[0] == this.customerCartID)[0]
            const updateCart = this.countCart + (currentCart.itemQty * (param.val ? 1 : -1))
            store.commit("purchaseticket/CHANGE_SELECTED", param);
            store.commit("purchaseticket/GETQTYCART_SUCCESS", updateCart);
          } else {
            const param = {
              index: this.index,
              val: response.data
            }
            const currentCart = this.items.filter(fx => fx.customerCartIDs[0] == this.customerCartID)[0]
            const updateCart = this.countCart + (currentCart.itemQty * (param.val ? 1 : -1))
            store.commit("purchaseticket/CHANGE_SELECTED", param);
            store.commit("purchaseticket/GETQTYCART_SUCCESS", updateCart);
          }
        })
        .catch((err) => {
          console.log(err);
        });

      if (this.discountData.data) {
        let discData = this.discountData.data
        payload = {
          ...discData,
          customer_id: store.state.auth.userData.customerID,
          partner_id: store.state.auth.userData.partnerID,
          amount_transaction: this.subTotal[0] || this.subTotal
        }
        if (payload.discount_id != "") {
          await this.$store.dispatch("discount/validation", payload)
          .then(res => {
            if (res.status) {
              const val = {
                name: discData.code,
                value: res.data.discount_price,
                type: discData.type,
                data: discData
              }
              store.commit("purchaseticket/SET_DISCOUNT", val);
            }
          })
          .catch(err => {
            console.log(err)
            const val = {
              value: 0
            }
            store.commit("purchaseticket/SET_DISCOUNT", val);
          })
        }
      }
    },
    convertPriceByCurrency(price, currency) {
      const conversionRates = this.$store.state.purchaseticket.currency ? this.$store.state.purchaseticket.currency.conversionRates : null;
      const priceResult = price * conversionRates[currency];
      return priceResult;
    },
  },

  watch: {
    value: {
      handler: function (newVal) {
        this.newValue = newVal;
      },
    },
  },
  created: function () {
    this.newValue = this.value;
    this.lastprice = this.price;
    // console.log(this.routeInformation)
  },
};
</script>

<style lang="scss" scoped>
hr {
  border: none;
  height: 1px;
  background-color: #ccc;
  margin: 4px 0;
}

.pr-price {
    align-content: center;
}

.num-135000-v-nd {
  // @include roboto-14-medium;
  font-size: 14px;
  font-weight: 700;
  color: rgba(242, 153, 0, 1);
}
</style>